import { AnyAction } from 'redux';
import { DemographicAppKeys } from '../../global/models/demographics-model';
import { AEInfo, AEPlanType, AESteps, AETierCalculations, AETiers, AnnualEnrollmentActionTypes, AnnualEnrollmentAppState, AnnualEnrollmentState } from './models/annual-enrollment-models';

const InitialState: AnnualEnrollmentState = {
	AEInfo: null,
	AEInfoLoaded: false,
	tierCalculations: null,
	currentStep: AESteps.PersonalInfo,
};

const InitialAppState: AnnualEnrollmentAppState = {
	[DemographicAppKeys.myCPG]: InitialState,
	[DemographicAppKeys.arc]: InitialState,
};

export const getInitialTierCalculations = (payload: AEInfo) => {
	const medicalTier = payload?.enrollments_base?.M[0]?.tier as AETiers;
	const dentalTier = payload?.enrollments_base?.D[0]?.tier as AETiers;

	return {
		[AEPlanType.Medical]: {
			display_tier: medicalTier,
			selected_tier: medicalTier,
		} as AETierCalculations,
		[AEPlanType.Dental]: {
			display_tier: dentalTier,
			selected_tier: dentalTier,
		} as AETierCalculations,
	};
};

export const annualEnrollmentReducerByApp = (state = InitialAppState, action: AnyAction): AnnualEnrollmentAppState => {
	const { app } = action;

	switch (action.type) {
		case AnnualEnrollmentActionTypes.SET_AE_INFO:
			return {
				...state,
				[app]: {
					...state[app],
					AEInfo: action.payload,
					AEInfoLoaded: true,
					tierCalculations: getInitialTierCalculations(action.payload),
				},
			};
		case AnnualEnrollmentActionTypes.SET_AE_CALC_TIERS:
			return {
				...state,
				[app]: {
					...state[app],
					tierCalculations: {
						...state[app].tierCalculations,
						[action.planType]: action.payload,
					},
				},
			};

		case AnnualEnrollmentActionTypes.CLEAR_AE_INFO:
			return {
				...state,
				[app]: {
					AEInfo: null,
					AEInfoLoaded: false,
					tierCalculations: null,
				},
			};
		case AnnualEnrollmentActionTypes.SET_AE_STEP:
			return {
				...state,
				[app]: {
					...state[app],
					currentStep: action.payload,
				},
			};

		default: return state;
	}
};

export const setAEInfo = (info: AEInfo, app: DemographicAppKeys) => {

	const copy = { ...info };
	if (!copy?.enrollments_base?.D && copy?.enrollments_base) copy.enrollments_base.D = [];
	if (!copy?.enrollments_base?.M && copy?.enrollments_base) copy.enrollments_base.M = [];
	return {
		type: AnnualEnrollmentActionTypes.SET_AE_INFO,
		payload: copy,
		app,
	};
};

export const clearAEInfo = (app: DemographicAppKeys) => {
	return {
		type: AnnualEnrollmentActionTypes.CLEAR_AE_INFO,
		app,
	};
};

export const setAECalcTiers = (calcTiers: AETierCalculations, planType: AEPlanType, app: DemographicAppKeys) => {
	return {
		type: AnnualEnrollmentActionTypes.SET_AE_CALC_TIERS,
		payload: calcTiers,
		planType,
		app,
	};
};

export const setAEStep = (step: AESteps, app: DemographicAppKeys) => {
	return {
		type: AnnualEnrollmentActionTypes.SET_AE_STEP,
		payload: step,
		app,
	};
};
